import { flatten, isEmpty } from "lodash";
import {
  paymentMethodsByCurrency,
  methods,
  PAYMENT_METHOD_LABELS,
} from "../PaymentMethods";

export const exchangeConverterIsFetching = (state) => {
  const { fetching } = state.pages.exchange;
  return fetching;
};

export const getExchangeConverterResult = (state) => {
  const { convertedCurrency } = state.pages.exchange;
  return convertedCurrency;
};

export const getPaymentMethodIdentifier = (state) => {
  const {
    pages: {
      payment: {
        payTransactionScreen: { paymentMethodIdentifier },
      },
    },
  } = state;
  return paymentMethodIdentifier;
};

export const getPaymentCreationState = (state) => {
  const {
    pages: {
      payment: { createPayment },
    },
  } = state;
  return createPayment;
};

export const getPaymentActionState = (state, action) => {
  try {
    const {
      pages: {
        payment: { paymentAction },
      },
    } = state;
    return paymentAction[action] || {};
  } catch {
    return {};
  }
};

export const getPaymentDataState = (state) => {
  return state.pages.payment.paymentData.payment;
};

export const getPaymentMethods = (state) => {
  const {
    pages: {
      payment: {
        paymentData: { paymentMethods },
      },
    },
  } = state;
  if (paymentMethods && paymentMethods.length > 0) {
    const methodsData = paymentMethods.map((method) => {
      return methods[method.paymentMethod];
    });
    return methodsData;
  }
  return [];
};

export const getPaymentMethodsByCurrency = (state) => {
  const { currency } = state.appGlobal.currency;
  const {
    pages: {
      payment: {
        paymentData: { paymentMethods },
      },
    },
  } = state;

  if (isEmpty(paymentMethods)) return [];

  const customPaymentMethods = paymentMethods.filter(
    (method) => method.paymentMethod === PAYMENT_METHOD_LABELS.customPayment
  );

  const methodsByCurrency = paymentMethodsByCurrency(
    currency,
    customPaymentMethods
  );

  const getMethodKey = (method) =>
    method.paymentMethod === PAYMENT_METHOD_LABELS.customPayment
      ? method._id
      : method.paymentMethod;

  const validPaymentMethods = paymentMethods.filter(
    (method) => methodsByCurrency[getMethodKey(method)]
  );

  const methodsData = validPaymentMethods.map(
    (method) => methodsByCurrency[getMethodKey(method)]
  );

  return flatten(methodsData);
};

export const getPaymentMethodsState = (state) => {
  const {
    pages: {
      payment: {
        paymentData: { paymentMethods },
      },
    },
  } = state;
  return paymentMethods;
};

export const getPaymentMethodsStateByPaymentIdentifier = (
  state,
  paymentMethodIdentifier
) => {
  const paymentMethods = getPaymentMethodsState(state);
  return paymentMethods.find((method) =>
    method.paymentMethod === PAYMENT_METHOD_LABELS.customPayment
      ? method._id === paymentMethodIdentifier
      : method.paymentMethod === paymentMethodIdentifier
  );
};
